export default __webpack_public_path__ + "static/media/80.474ac37a.png";